module.exports = __webpack_public_path__ + "static/media/foto11.a801bca2.png";